import { Step } from "@/components/Step";
import { StepConnector } from "@/components/StepConnector";

const ALL_SIGNUP_STEPS = [
  { number: 1, label: "Account" },
  { number: 2, label: "Profile" },
  { number: 3, label: "Advisory" },
  { number: 4, label: "Availability" },
];

// Achiever flow is 3 steps and its 3rd step is "Growth", not "Advisory" —
// distinct label sequence rather than a slice of ALL_SIGNUP_STEPS.
const ACHIEVER_SIGNUP_STEPS = [
  { number: 1, label: "Account" },
  { number: 2, label: "Profile" },
  { number: 3, label: "Growth" },
];

// Step progress bar using Step + StepConnector components
export const StepProgress = ({
  currentStep,
  totalSteps = 4,
  stepLabels,
}: {
  currentStep: number;
  totalSteps?: number;
  /** Override the default label sequence, e.g. the achiever flow's "Growth" 3rd step. */
  stepLabels?: string[];
}) => {
  const baseSteps = stepLabels
    ? stepLabels.map((label, i) => ({ number: i + 1, label }))
    : totalSteps === 3
      ? ACHIEVER_SIGNUP_STEPS
      : ALL_SIGNUP_STEPS;
  const steps = baseSteps.slice(0, totalSteps);
  return (
    <div className="relative flex items-start justify-between w-full">
      {/* Connector segments sit behind steps at the vertical center of the circles (44px / 2 - 2px = 20px) */}
      <div className="absolute inset-x-0 top-[20px] flex">
        {steps.slice(0, -1).map((step, index) => (
          <div key={`connector-${index}`} className="flex-1">
            <StepConnector active={step.number < currentStep} />
          </div>
        ))}
      </div>
      {steps.map((step) => {
        const status =
          step.number === currentStep
            ? "active"
            : step.number < currentStep
              ? "completed"
              : "upcoming";
        return <Step key={step.number} number={step.number} label={step.label} status={status} />;
      })}
    </div>
  );
};
